'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _getPrototypeOf = require('babel-runtime/core-js/object/get-prototype-of');

var _getPrototypeOf2 = _interopRequireDefault(_getPrototypeOf);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _possibleConstructorReturn2 = require('babel-runtime/helpers/possibleConstructorReturn');

var _possibleConstructorReturn3 = _interopRequireDefault(_possibleConstructorReturn2);

var _inherits2 = require('babel-runtime/helpers/inherits');

var _inherits3 = _interopRequireDefault(_inherits2);

var _extends2 = require('babel-runtime/helpers/extends');

var _extends3 = _interopRequireDefault(_extends2);

var _dec, _class;

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _moment = require('moment');

var _moment2 = _interopRequireDefault(_moment);

var _reactRedux = require('react-redux');

var _components = require('components');

var _underscore = require('underscore');

var _underscore2 = _interopRequireDefault(_underscore);

var _RestartSubscriptionPopup = require('@quixeltools/quixel-ui-library/dist/components/megascans/account/RestartSubscriptionPopup');

var _RestartSubscriptionPopup2 = _interopRequireDefault(_RestartSubscriptionPopup);

var _AppSideEffects = require('../AppSideEffects/AppSideEffects');

var _AppSideEffects2 = _interopRequireDefault(_AppSideEffects);

var _subscriptions = require('redux/modules/subscriptions');

var subscriptionService = _interopRequireWildcard(_subscriptions);

var _utils = require('utils');

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var RestartSubscriptionPopup = (_dec = (0, _reactRedux.connect)(function (state) {
  return {
    plans: state.subscriptions,
    subscription: state.user.subscription
  };
}, (0, _extends3.default)({}, subscriptionService)), _dec(_class = function (_React$Component) {
  (0, _inherits3.default)(RestartSubscriptionPopup, _React$Component);

  function RestartSubscriptionPopup(props) {
    (0, _classCallCheck3.default)(this, RestartSubscriptionPopup);

    var _this = (0, _possibleConstructorReturn3.default)(this, (RestartSubscriptionPopup.__proto__ || (0, _getPrototypeOf2.default)(RestartSubscriptionPopup)).call(this, props));

    _this.state = {
      successful: false,
      subscribing: false
    };

    _this.onCancelled = _this.onCancelled.bind(_this);
    _this.onAborted = _this.onAborted.bind(_this);
    return _this;
  }

  (0, _createClass3.default)(RestartSubscriptionPopup, [{
    key: 'componentDidMount',
    value: function componentDidMount() {
      this.props.getSubscriptionPlans();
    }
  }, {
    key: 'isSubscribing',
    value: function isSubscribing(_isSubscribing) {
      this.setState({
        subscribing: _isSubscribing
      });
    }
  }, {
    key: 'onCancelled',
    value: function onCancelled() {
      var _this2 = this;

      console.log(this.props);
      this.isSubscribing(true);
      this.props.resumeSubscription().then(function () {
        _this2.isSubscribing(false);
        _this2.props.onCloseYes();
      }, function () {
        _this2.isSubscribing(false);
        _this2.props.onCloseYes();
      });
    }
  }, {
    key: 'onAborted',
    value: function onAborted() {
      this.props.onCloseYes();
    }
  }, {
    key: 'getCurrentPlan',
    value: function getCurrentPlan() {
      var _props = this.props,
          subscription = _props.subscription,
          plans = _props.plans;


      var plan = _underscore2.default.find(plans.plans, function (p) {
        return p.type === subscription.planId;
      });

      return plan;
    }
  }, {
    key: 'render',
    value: function render() {
      var _props2 = this.props,
          _props2$subscription = _props2.subscription,
          expiresAt = _props2$subscription.expiresAt,
          planName = _props2$subscription.planName,
          multiSeat = _props2$subscription.multiSeat,
          numberOfSeats = _props2$subscription.numberOfSeats,
          plans = _props2.plans;

      var expiryDate = (0, _moment2.default)(expiresAt).format('MMMM Do, YYYY');

      var plan = this.getCurrentPlan();
      var planPoints = plan && ' ' + plan.points + ' points / ' + (plan.billing.toLowerCase() === 'monthly' ? 'month' : plan.billing.toLowerCase() === 'annual' ? 'year' : '');
      var planCost = plan && (multiSeat || numberOfSeats > 0 ? (0, _utils.prettyDollars)(plan.amount) + ' x ' + numberOfSeats : (0, _utils.prettyDollars)(plan.amount)) + ' / ' + (plan.billing.toLowerCase() === 'monthly' ? 'month' : plan.billing.toLowerCase() === 'annual' ? 'year' : '');

      return _react2.default.createElement(
        _AppSideEffects2.default,
        null,
        _react2.default.createElement(_RestartSubscriptionPopup2.default, {
          icon: '/quixel_2080_logo.png',
          title: 'Reactivate Subscription',
          planName: planName,
          planPoints: plans.gettingPlans ? null : planPoints,
          planCost: plans.gettingPlans ? null : planCost,
          onSubscribeClick: this.onCancelled,
          subscribing: this.state.subscribing
        })
      );
    }
  }]);
  return RestartSubscriptionPopup;
}(_react2.default.Component)) || _class);
exports.default = RestartSubscriptionPopup;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./src/components/RestartSubscriptionPopup/RestartSubscriptionPopup.js
// module id = 2598
// module chunks = 0